import React from 'react';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import Dumbo from '../../../../DeviationViews/Dumbo';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import s from './DeviationPromo.scss';
const DeviationPromo = ({ href, onClick, biData, heading, subheading, deviation, attributionSlot, logoSlot, ctaSlot })=>{
    const { ref, dimensions } = useMeasureElementCookie(MeasuredCookieType.DEVIATION_SIDEBAR_PROMO, {
        cookieDim: 'width'
    });
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: s['root'],
        href: href,
        onClick: onClick,
        biData: biData
    }, /*#__PURE__*/ React.createElement(Section, null, /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: s['top-section']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['deviation-wrapper']
    }, deviation && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Dumbo, {
        deviation: deviation,
        width: dimensions === null || dimensions === void 0 ? void 0 : dimensions.width,
        height: 224,
        "aria-hidden": "true",
        useCoverMode: true
    }), attributionSlot && /*#__PURE__*/ React.createElement("p", {
        className: s['attribution']
    }, attributionSlot))), /*#__PURE__*/ React.createElement(Heading, {
        className: s['heading']
    }, heading), /*#__PURE__*/ React.createElement("p", {
        className: s['description']
    }, subheading)), /*#__PURE__*/ React.createElement("div", {
        className: s['divider']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['bottom-section']
    }, logoSlot, ctaSlot)));
};
DeviationPromo.displayName = 'DeviationPromo';
export default DeviationPromo;

//# sourceMappingURL=DeviationPromo.js.map